import { render, staticRenderFns } from "./TextInputPopup.vue?vue&type=template&id=70112670&scoped=true&"
import script from "./TextInputPopup.vue?vue&type=script&lang=js&"
export * from "./TextInputPopup.vue?vue&type=script&lang=js&"
import style0 from "./TextInputPopup.vue?vue&type=style&index=0&id=70112670&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70112670",
  null
  
)

export default component.exports